import React from 'react';
import axios from 'axios';
import { getClickIds, getFunnel, getAffiliateParams } from '../utils/tracking';
import Navbar from '../components/variant/Navbar';
import Header from '../components/variant/HomeHeader';
import Testimonials from '../components/variant/Testimonials';
import PlatformAndFeatures from '../components/variant/PlatformAndFeatures';
import Pricing from '../components/variant/Pricing';
import FeatureCards from '../components/variant/FeatureCards';
import WhyFollowers from '../components/variant/WhyFollowers';
import FAQ from '../components/variant/FAQ';
import Footer from '../components/variant/Footer';
import StickyCta from '../components/variant/StickyCta';

// A/B landing page served on the variant domain (startviralgpt.com). It mirrors
// pages/Home.js as a clone-to-restyle base, but every CTA routes back to the
// main site (viralgpt.com) via mainUrl() inside the variant/* components.
//
// Attribution note: the affiliate ?r= cookie and ttclid are written with
// domain=.viralgpt.com, which the browser rejects on this domain — and
// viralgpt.com can't read a startviralgpt.com cookie anyway. So we DON'T try to
// share a cookie across domains. Instead:
//   - LanguageProvider writes a host-only affiliate cookie here (for sticky
//     language + ?r= forwarding), and
//   - mainUrl() forwards r / ttclid / fbclid on every CTA link, so when the
//     visitor reaches viralgpt.com the cookie is written there on the right
//     domain by the existing logic.
const HomeVariant = () => {
  // Ad traffic (including rise-*) lands on the marketing home like everyone
  // else. It used to drop those clicks straight onto the bare plan picker,
  // skipping the offer, the proof and the FAQ — everything that earns the
  // click. The pricing block is on this page, so plans are one scroll away.

  React.useEffect(() => {
    // ttclid/fbclid + affiliate cookies are written globally by LanguageProvider
    // (host-only on this domain) and forwarded to viralgpt.com via mainUrl() on
    // every CTA. Here we also pass the click ids in the /pixel body because this
    // domain's host-only cookie can't be sent cross-domain to api.viralgpt.com.
    const fire = (event) =>
      axios.post('https://api.viralgpt.com/pixel', { event, funnel: getFunnel(), ...getClickIds(), ...getAffiliateParams() }, {
        withCredentials: true,
      }).catch(err => console.error('Error sending pixel data:', err));

    // home_view only. ViewContent/PlansView belong to the pricing page — firing
    // them on a home view would stop that funnel step discriminating.
    fire('home_view');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ overflowX: 'hidden' }}>
      <Navbar />
      <Header />
      <Testimonials />
      <PlatformAndFeatures />
      <Pricing />
      <FeatureCards />
      <WhyFollowers />
      <FAQ />
      <Footer />
      <StickyCta />
    </div>
  );
};

export default HomeVariant;
